// src/season-cluster/infrastructure/ui-services/seasonUiService.ts

export const $SEASON_ROUTE_QUERY_NAME = "split";

export const $SEASONS_WITHOUT_DATA: number[] = [8, 1, 2];

//season ids for world cup events, nations & clubs
export const $SEASONS_WORLD_CUP: number[] = [13, 14, 28, 37];

//season ids for nations with group tables
export const $SEASONS_NATIONS_GROUPS: number[] = [49];

export const $SEASON_SPECIAL_CUPS: Record<number, string> = {
  45: "Spain",
  44: "Germany",
  43: "Brazil",
  42: "Italy",
  48: "Mexico",
  47: "Mexico",
  46: "Spain",
};

/**
 * Competitions that are shared between multiple regions
 * These competitions appear in the data of multiple regions (different apiIds)
 * but each team/player should only see the region of their country.
 */
export const SHARED_COMPETITIONS = [28, 29, 30] as const;

/**
 * Descriptive map of shared competitions
 */
export const SHARED_COMPETITIONS_MAP = {
  28: "KC America",
  29: "KC Europe",
  30: "Queens Cup",
} as const;
